@if (isAnimatingIcon()) {
  <div class="overlay" style="position: absolute; inset: 0; background: rgba(0, 0, 0, 0.5)" @fade></div>
}

<app-style-sheet-sprite
  [sprite]="_stylesService.WK8_TUTOR_PANEL()?.container"
  [borders]="['RIGHT']"
  [text]="_stylesService.WK8_TUTOR_PANEL()?.text"
  style="font-size: calc(0.75 * (1vw + 1vh))"
>
  <div #rootEl>
    <div class="sentence" style="color: black">
      <ng-content></ng-content>
    </div>

    <div #iconContainerEl class="icon" style="display: grid; place-items: center">
      <img #iconEl src="" alt="" style="height: 5em; object-fit: contain" />
      <h3 #iconTitleEl style="height: 1em; font-weight: bold"></h3>
    </div>

    @let info = tutorService.mechanicInfo();
    @if (info) {
      <div class="info" style="margin-top: 1em">
        <div class="title" style="position: relative">
          <h2 style="font-size: 1.5em; color: white; font-weight: bold">{{ info.title ?? '???' }}</h2>
          @if (info.tutorial) {
            <wk8-button
              color="blue"
              icon="info"
              style="position: absolute; right: -2em; top: 50%; width: 2em; height: 2em; translate: 0 -50%"
              (clicked)="tutorService.playTutorial(info)"
              [disabled]="disablePlayTutorialButton()"
            />
          }
        </div>
        <p style="color: #b8b9ba">{{ info.description ?? '???' }}</p>
      </div>
    }

    @if (tutorService.isChecking()) {
      <div class="wrapper" style="position: absolute; left: 0; right: -8%; bottom: 0" @slidedown>
        <app-style-sheet-sprite
          [sprite]="_stylesService.WK8_TUTOR_PANEL()?.container"
          [borders]="['TOP', 'RIGHT']"
          [text]="_stylesService.WK8_TUTOR_PANEL()?.text"
        >
          <div style="display: grid; gap: 1em; grid-template-areas: 'danger success'; grid-template-columns: 1fr 1fr">
            <wk8-button
              color="orange"
              icon="squiggle"
              [disabled]="!tutorService.isChecking()"
              (clicked)="tutorService.markPractice()"
              style="aspect-ratio: 1"
            ></wk8-button>
            <wk8-button
              color="green"
              icon="checkmark"
              [disabled]="!tutorService.isChecking()"
              (clicked)="tutorService.markSuccess()"
              style="aspect-ratio: 1"
            ></wk8-button>
          </div>
        </app-style-sheet-sprite>
      </div>
    }

    @if (tutorService.isRequiringAction()) {
      <div class="wrapper" style="position: absolute; bottom: 0; right: -2em; left: 7em" @slidedown>
        <app-style-sheet-sprite [sprite]="_stylesService.WK8_TUTOR_PANEL()?.container" [text]="_stylesService.WK8_TUTOR_PANEL()?.text">
          <div style="display: grid; padding-left: 0.75em; padding-bottom: 0.75em">
            <app-hud-button kind="PRIMARY" (click)="tutorService.markActionFinished()">
              <p style="margin: -4px; font-size: 12px; font-weight: bold">{{ tutorService.action() }}</p>
            </app-hud-button>
          </div>
        </app-style-sheet-sprite>
      </div>
    }

    @if (tutorService.isRequiringChoice()) {
      <div class="wrapper" style="position: absolute; bottom: 0; inset-inline: 0" @slidedown>
        <app-style-sheet-sprite [sprite]="_stylesService.WK8_TUTOR_PANEL()?.container" [text]="_stylesService.WK8_TUTOR_PANEL()?.text">
          <div style="display: grid; gap: 1em">
            @for (choice of tutorService.choices(); track $index) {
              <app-hud-button kind="PRIMARY" (click)="tutorService.markChoice(choice)">{{ choice }}</app-hud-button>
            }
          </div>
        </app-style-sheet-sprite>
      </div>
    }
  </div>
</app-style-sheet-sprite>
